<template>
  <Layout>
    <div class="h-screen bg-grey-lighter flex justify-center items-center">
      <div class="bg-white border rounded py-8 px-8 w-full md:w-2/3 lg:w-1/3 login-form">
        <div class="flex justify-start">
          <div class="w-full">
            <Logo />
            <h2 class="login-form-title">Login</h2>
          </div>
        </div>
        <div class="flex items-center mb-2">
          <div class="w-1/4 login-form-label mb-2">
            Username
          </div>
          <div class="w-3/4">
            <pt-form-input
              id="username"
              v-model="username"
              type="text"
              placeholder="Enter your username here"
              class="mb-0"
              @keyup.enter.native="getGoogleToken"
            />
          </div>
        </div>
        <div class="flex items-center">
          <div class="w-1/4 login-form-label mb-2">
            Password
          </div>
          <div class="w-3/4">
            <pt-form-input
              id="password"
              v-model="password"
              type="password"
              placeholder="Enter your password here"
              @keyup.enter.native="getGoogleToken"
            />
          </div>
        </div>

        <div class="flex lg:flex-row sm:flex-col justify-end mt-8">
          <div class="">
            <pt-button
              :disabled="loggingIn"
              :class="{
                'opacity-50 cursor-not-allowed': loggingIn
              }"
              class="login-button"
              variant="primary"
              @action="getGoogleToken"
            >
              {{ loggingIn ? 'Logging In...' : 'Log In' }}
            </pt-button>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { PtFormInput } from '@pathao/ui-components/esm/FormComponents';
import Logo from '@components/navigation/Logo';
import Layout from '@layouts/unauth';
import isPWA from '@src/utils/is-pwa';

export default {
  page: {
    title: 'Resto | Sign in',
  },
  components: {
    Layout,
    PtFormInput,
    Logo,
  },
  data() {
    return {
      username: '',
      password: '',
    };
  },
  computed: mapGetters({
    loggingIn: 'auth/loggingIn',
    currentUser: 'auth/user',
    userPermissions: 'auth/permissions',
  }),
  mounted() {
    const queryParams = new URLSearchParams(document.location.search.substring(1));
    const code = queryParams.get('code');

    if (code) {
      this.logIn(code).then((result) => {
        window.location.reload();
      }).catch(() => {
        this.$noty.error('Failed to log in, please try again.');
      });
    }
  },
  methods: {
    getGoogleToken() {
      this.logIn({ username: this.username, password: this.password })
        .then(() => {
        // console.log(result);
          const page404 = '404';
          const adminDashboard = 'users';
          const userDashboard = 'orders';
          const restoAdminDashboard = 'branches';
          const historyRoute = 'history';

          let redirectPath = page404;

          if (this.userPermissions.includes('can_crud_orders')) {
            this.$sendEvent('RS_site');
            redirectPath = userDashboard;
          } else if (this.userPermissions.includes('can_crud_users')) {
            redirectPath = adminDashboard;
          } else if (this.currentUser.is_resto_admin) {
            redirectPath = restoAdminDashboard;
          } else if (this.userPermissions.includes('can_crud_histories')) {
            redirectPath = historyRoute;
          }
          this.$sendEvent('RS_login');
          if (isPWA()) {
            this.$sendEvent('RS_PwaApp');
          } else {
            this.$sendEvent('RS_WebApp');
          }
          this.$router.push({ name: redirectPath }).catch(err => { console.log(err); });
        }).catch((error) => {
          let message = (error.response && error.response.data)
            ? error.response.data.message
            : 'Failed to load token';
          this.$notification.error(message);
        });
    },
    ...mapActions({
      logIn: 'auth/logIn',
    }),
  },
};
</script>

<style>
  .login-form {
    border: 1px solid #DDDDDD;
    box-shadow: 0 2px 6px 0 rgba(0,0,0,0.24);
    border-radius: 2px;
  }
  .login-form-label {
    font-size: 16px;
    font-weight: 600;
    color: #545454;
    text-align: left;
    line-height: 24px;
  }
  .login-form-title {
    font-size: 24px;
    font-weight: normal;
    padding: 25px 0px;
    color: #000000;
    line-height: 32px;
  }
  .pt-input-container #username, #password {
    background: #FFFFFF;
    /*border: 0.5px solid #8E8E93;*/
    border-radius: 2px;
    line-height: 24px;
  }
  .login-button {
    height: unset;
    padding-top: 10px;
    padding-bottom: 10px;
  }
</style>
